module.exports = __webpack_public_path__ + "img/deleteImageWhite.9061ce3d.svg";